import { render, staticRenderFns } from "./ListadoProgramaUniversidad.vue?vue&type=template&id=400677e7"
import script from "./ListadoProgramaUniversidad.vue?vue&type=script&lang=js"
export * from "./ListadoProgramaUniversidad.vue?vue&type=script&lang=js"
import style0 from "./ListadoProgramaUniversidad.vue?vue&type=style&index=0&id=400677e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports